<template>
  <CafeteriaDeliveriesList/>
</template>
<script>
import CafeteriaDeliveriesList from '@/components/modules/cafeteria/deliveries/list'
export default {
  name: 'CafeteriaDeliveries',
  components: {
    CafeteriaDeliveriesList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cafeteria/deliveries/list.vue